import React from "react"
import tw from "twin.macro"

import { withSubscribeFooter } from "./withSubscribeFooter"
import { Subscribe } from "./Subscribe"
// import { StyledH2 } from "../Styled/Text"

const Container = tw.div`w-full md:w-35 flex flex-col md:pr-7-2`
// const Description = tw.div`mb-2-4 mt-1 w-5/12 leading-1.14 text-14 md:w-5/6 md:text-18`
const Description = tw.div`mb-2-4 mt-1 w-5/12 md:w-5/6`
const Error = tw.div`
  text-12 mt-1-6 p-1 text-punch font-medium rounded-0-2
`
const FormWrapper = tw.div`w-3/4 md:w-full`

const SuccessMessage = tw.div`flex border border-dark text-14 text-center px-1-2 h-3-2 md:text-20 md:px-2 md:h-4 rounded-1 font-body tracking-relaxed w-30 md:w-full items-center justify-center`
const Title = tw.div`block`
// const Title = tw(StyledH2)`block`
// const Title = tw(StyledH2)`block font-medium text-20 md:text-26`  // font chnage

const FooterSubscribe = withSubscribeFooter(({ data, handleChange, handleSubmit, errors, title, description, successMessage, success, loading }) => {
  return (
    <Container>
      {title?.map((text: string, index: number) => (
        // <StyledH2 key={index}>{text}</StyledH2>
        <Title className="footer_heading" key={index}>
          {text}
        </Title>
      ))}

      <Description className="body_regular">{description}</Description>
      {!success ? (
        <FormWrapper>
          <Subscribe data={data} handleChange={handleChange} handleSubmit={handleSubmit} loading={loading} />
          {errors?.length > 0 &&
            errors?.map(({ code, message }) => (
              <Error key={code}>{message === "Email has already been taken" ? "This email address is already subscribed." : message}</Error>
            ))}
        </FormWrapper>
      ) : (
        <SuccessMessage>{successMessage}</SuccessMessage>
      )}
    </Container>
  )
})

export default FooterSubscribe
